export default function checkExcelData(data) {
  const errors = [];
  const sciNotationRegex = /^[+-]?\d+(\.\d+)?[eE][+-]?\d+$/;
  const formattedData = data.map((row, rowIndex) => {
    return row.map((cell, colIndex) => {
      if (cell !== undefined && cell !== null) {
        const cellValue = String(cell).trim();

        if (sciNotationRegex.test(cellValue)) {
          errors.push(`Error de formato en Fila ${rowIndex + 1}, Columna ${colIndex + 1}: "${cellValue}" . Por favor validar el formato, para este caso, por favor enviar la información en formato texto`)
        }

        return cellValue;
      }
      return cell;
    });
  });

  return { formattedData, errors };
}
